import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../layout/Box/index';
import Icon from '../widgets/Icon/index';
import './styles.scss';

const NotificationMessage = ({kind, message}) => {
  const ICON_KIND = {
    'success': 'check',
    'warning': 'exclamation',
    'alert': 'exclamation-triangle',
  };

  return (
    <div className={classnames('notification-message', 'callout', kind)}>
      <Box direction="row" className="notification-message__content" justifyContent="space-between">
        <span className="notification-message__message">{message}</span>
        <Icon name={ICON_KIND[kind]}/>
      </Box>
      <div className="notification-message__close"/>
    </div>
  );
};

NotificationMessage.defaultProps = {
  kind: 'info',
};

NotificationMessage.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  message: PropTypes.node.isRequired,
  kind: PropTypes.oneOf([
    'success',
    'info',
    'warning',
    'danger',
  ]).isRequired,
  componentClassName: PropTypes.string,
  onActionClick: PropTypes.func,
  actionLabel: PropTypes.string,
};

export default NotificationMessage;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/NotificationMessage/index.js